export default {"src":"/_next/static/media/check.f5bae8f2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};